import { useField, useForm } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { Radio, RadioProps } from './Radio'

export type RadioFieldProps<Item> = Omit<RadioProps<Item>, 'value' | 'onChange' | 'items'> & {
  name: string
  items: Item[]
  validate?: FieldValidator<Item>
  displayErrorIfUntouched?: boolean
  onChange?: (value: Item | null) => void
}

export function RadioField<Item extends { id: string; title?: string }>({
  name,
  items,
  validate,
  displayErrorIfUntouched,
  onChange,
  ...props
}: RadioFieldProps<Item>) {
  const form = useForm()
  const { input, meta } = useField<Item>(name, { validate })

  const errorMessage = meta.error || meta.submitError
  const showError = displayErrorIfUntouched ? errorMessage : meta.touched && errorMessage

  return (
    <Radio
      {...props}
      items={items}
      value={input.value ?? null}
      onChange={(value) => {
        form.change(name, value ?? undefined)
        onChange?.(value)
      }}
      error={Boolean(showError)}
      helperText={showError || undefined}
    />
  )
}
